module.exports = __webpack_public_path__ + "79a3f577fbf023471c688767360619fc.fbx";